import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import StatusMessage from "../../../presentational/StatusMessage";
import * as StatusMessages from "../../../../constants/StatusMessages";
import { defineMessages, FormattedMessage } from "react-intl";
import track from "react-tracking";
import AccountFormGroups from "assets/scripts/components/common/form/AccountFormGroups/AccountFormGroups";
import { loadEmailOptOuts, optOutEmailSecure } from "assets/scripts/domain/accts/acctsActions";
import useAccounts from "assets/scripts/hooks/useAccounts";
import Form from "assets/scripts/components/common/form/Form/Form";
import RadioFormGroup from "assets/scripts/components/common/form/RadioFormGroup/RadioFormGroup";
import { retrieveProfile } from "assets/scripts/domain/profile/profileActions";
import styles from "./EmailOptOutSecure.module.less";
const messages = defineMessages({
    optOutEmailYes: {
        id: "profile.okEmail.yes.explicit",
        defaultMessage: "I do not want to receive email."
    },
    optOutEmailNo: {
        id: "profile.okEmail.no.explicit",
        defaultMessage: "I consent to receiving emails."
    }
});
function EmailOptOutSecure(props) {
    const accounts = useAccounts();
    const routeGroups = [...accounts.accts.deceased, ...accounts.accts.live];
    const [selectedAccounts, setSelectedAccounts] = useState([]);
    const [optOutEmail, setOptOutEmail] = useState(false);
    const [initialized, setInitialized] = useState(false);
    if (!initialized) {
        if (!props.profile) {
            props.retrieveProfile();
        }
        setInitialized(true);
        props.loadEmailOptOuts().then((resp) => {
            const refNums = resp;
            setSelectedAccounts(Object.fromEntries(refNums.map(((refNum) => [refNum, true]))));
            setOptOutEmail(props.profile.okEmail !== 'yes');
        });
    }
    const _handleAccountChange = (accnts) => {
        setSelectedAccounts(accnts);
    };
    const _handleRadioChange = (okEmail) => {
        setOptOutEmail(okEmail === "" ? false : okEmail === "yes");
    };
    return (<div className="wrapper wrapper_narrow">
			<div className="vr vr_x4">
				<h1 className="hdg js-pageHeader">
					<FormattedMessage id="emailOptOut.header" defaultMessage="Email Preferences"/>
				</h1>
			</div>

			<StatusMessage isLoad isActive={props.emailOptOutIsLoading || props.emailOptOutDataIsLoading || accounts.loading}/>

			{!accounts.loading && initialized && props.emailOptOutDataIsSuccess && accounts.error == null && (<Fragment>
					<Form isBusy={props.emailOptOutIsLoading} isValid hideRequiredMessage submitLabel={<FormattedMessage id="forms.profileEdit.submit" defaultMessage="Save"/>} onSubmit={() => {
        const keys = Object.keys(selectedAccounts);
        const values = Object.values(selectedAccounts);
        props.optOutEmailSecure(keys
            .filter((_, index) => {
            if (process.env.CLIENT === "CapOne") {
                return values[index];
            }
            return optOutEmail;
        })
            .map(k => +k));
    }}>
						<StatusMessage isError={!props.emailOptOutIsSuccess} isSuccess={props.emailOptOutIsSuccess} isActive={props.emailOptOutIsSuccess !== null ? true : false} customMessage={props.emailOptOutIsSuccess ?
        StatusMessages.EMAILOPTOUT.SUCCESS :
        ""} domain="emailOptOut" autoReset={false}/>
						<StatusMessage isError isActive={props.emailOptOutError ? true : false} error={props.emailOptOutError ? props.emailOptOutError : null} customMessage={StatusMessages.EMAILOPTOUT.FAIL} domain="emailOptOut" autoReset={false}/>
						{process.env.CLIENT === "CapOne" && (<div>
								<div className="vr vr_x5">
									<div className="text">
										<p>
											<FormattedMessage id="emailOptOut.message" defaultMessage="At any point, you may revoke authorization for the Estate Cares team to contact you regarding the account(s) at the email address provided by notifying Capital One. Please note, you may continue to receive systemic emails from the Estate Cares site or the purpose of providing you with site access (e.g. username retrieval, password resets, etc.)."/>
										</p>
										<p>
											<FormattedMessage id="emailOptOut.select" defaultMessage="Please select applicable estate accounts to opt out:"/>
										</p>
									</div>
								</div>

								<div className="vr vr_x5 account_checkboxes">
									<AccountFormGroups label={null} routeGroups={routeGroups} selectedIds={selectedAccounts} onChange={_handleAccountChange} useRefNum hideBalance/>
								</div>

								<div className="vr vr_x5">
									<div className="text">
										<p>
											<FormattedMessage id="emailOptOut.message2" defaultMessage="You may also notify us via phone at 855-234-1142 or mail at Capital One, P.O. Box 815, Minneapolis, MN 55440-0815. It may take up to one business day from the receipt of such request for the update to be completed in our system."/>
										</p>
									</div>
								</div>
							</div>)}

						{process.env.CLIENT !== "CapOne" && (<div>
								<h2 className="hdg hdg_2 vr vr_x2">
									<FormattedMessage id="emailOptOut.consent.title" defaultMessage="Consent:"/>
								</h2>

								<div className="vr vr_x5">
									<div className="vr vr_x3">
										<div className="text">
											<FormattedMessage tagName="p" id="profile.okEmail.authorize1" defaultMessage={"I authorize DCM Services, LLC (DCMS), debt collector, to contact me with the information "
        + "I provided (e-mail, phone, address) in an attempt to collect the debt from the estate. "
        + "I understand that any information provided will be used for that purpose."}/>
										</div>
									</div>
									<RadioFormGroup name="optOutEmail" label={null} value={(optOutEmail == null ? ""
        : optOutEmail ? "yes"
            : "no")} onChange={_handleRadioChange} options={[{
            value: "no",
            label: messages.optOutEmailNo
        }]} suppressAria/>
								</div>

								<h2 className="hdg hdg_2 vr vr_x2">
									<FormattedMessage id="emailOptOut.optOut.title" defaultMessage="Opt Out:"/>
								</h2>

								<div className="vr vr_x5">
									<div className="vr vr_x3">
										<div className="text">
											<FormattedMessage tagName="p" id="profile.okEmail.authorize2" defaultMessage="You can opt out of email using one of the following ways, at any time. It may take up to 24 hours from receipt of such a request to be completed on our system."/>

											<ol type="1" className={styles.listNumbered}>
												<li>
													<FormattedMessage id="profile.okEmail.authorize2.a" defaultMessage={"Through the Email Preferences section of site once logged in"}/>
												</li>
												<li>
													<FormattedMessage id="profile.okEmail.authorize2.b" defaultMessage={"Through the opt-out hyperlink received in the email communication, or"}/>
												</li>
												<li>
													<FormattedMessage id="profile.okEmail.authorize2.c" defaultMessage={"Call DCMS tollfree at 1-877-326-8786"}/>
												</li>
											</ol>

											<FormattedMessage tagName="p" id="profile.okEmail.authorize3" defaultMessage={"Once you opt out, DCMS will not communicate with you via email nor will it be able to email "
        + "you for the limited purpose of providing you with site access (e.g., username retrieval, "
        + "password resets) unless you give DCMS permission."}/>
										</div>
									</div>

									<RadioFormGroup name="optOutEmail" label={null} value={(optOutEmail == null ? ""
        : optOutEmail ? "yes"
            : "no")} onChange={_handleRadioChange} options={[{
            value: "yes",
            label: messages.optOutEmailYes
        }]} suppressAria/>
								</div>
							</div>)}
					</Form>
				</Fragment>)}
		</div>);
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    profile: state.profile.profile,
    emailOptOutError: state.accts.emailOptOut.error,
    emailOptOutIsLoading: state.accts.emailOptOut.isLoading,
    emailOptOutIsSuccess: state.accts.emailOptOut.isSuccess,
    emailOptOutDataError: state.accts.emailOptOut.dataError,
    emailOptOutDataIsLoading: state.accts.emailOptOut.dataIsLoading,
    emailOptOutDataIsSuccess: state.accts.emailOptOut.dataIsSuccess,
});
const bindActionsToProps = {
    optOutEmailSecure,
    retrieveProfile,
    loadEmailOptOuts
};
/* Create and export container component that wraps EmailOptOutSecure for property binding */
export default track({ page: "EmailOptOutSecure" }, { dispatchOnMount: true })(connect(mapStateToProps, bindActionsToProps)(EmailOptOutSecure));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/EmailOptOutSecure/EmailOptOutSecure.tsx